// Account-specific bundle
// Dependencies
import { _ } from './utils'
import CheckPostcodeRequired from './modules/check-post-code-required'
import CheckRequired from './modules/check-required'
import OriginalListing from './modules/original-listing'
import PasswordReveal from './modules/password-reveal'
import RevealCheckbox from './modules/reveal-checkbox'
import SelectUrl from './modules/select-url'
import Tabs from './modules/tabs'
import Tooltip from './modules/tooltip'
import Consents from '@/javascript/modules/consents'
import SearchModal from './modules/search-modal'

// Initialize required behaviours on account pages
_('', 'check-postcode-required')
    .nodes()
    .forEach((el) => new CheckPostcodeRequired(el))

_('', 'required')
    .nodes()
    .forEach((el) => new CheckRequired(el))

_('original-listing')
    .nodes()
    .forEach((el) => new OriginalListing(el))

_('password-reveal')
    .nodes()
    .forEach((el) => new PasswordReveal(el))

_('reveal-checkbox')
    .nodes()
    .forEach((el) => new RevealCheckbox(el))

_('select-url')
    .nodes()
    .forEach((el) => new SelectUrl(el))

_('tab-trigger')
    .nodes()
    .forEach((el) => new Tabs(el))

_('tooltip', 'element')
    .nodes()
    .forEach((el) => new Tooltip(el))

_('unsub-from-all', 'element')
    .nodes()
    .forEach((el) => new Consents(el))

const siteSearchModal = document.querySelector('[data-element="site-search"].site-search')
if (siteSearchModal) {
    new SearchModal(siteSearchModal)
}
